import React from 'react';

import styles from './landing-page-body.module.css';
import sharedStyles from '../../sharedStyles.module.css';
import Stepper from './stepper';
import { useFetchRequestAccessForm } from '../../api/hooks/useFetchRequestAccessForm';
import Message from '../Message';
import { MainContentContainer } from '../main-content-container';

const LandingPageBody = () => {
    const { data } = useFetchRequestAccessForm();

    return (
        <MainContentContainer className={styles.container}>
            <div className={styles.content}>
                {data?.logoUrl && (
                    <img src={data?.logoUrl} alt="Company Logo" className={styles.logoImage} />
                )}
                <div className={styles.text}>
                    <h1 className={sharedStyles.textHeadline}>{data?.companyName}</h1>
                    <Message
                        className={styles.textAlign}
                        code="app.request.access.public.landingpage.subheader"
                    ></Message>
                </div>
            </div>
            {data?.customMessage && <span className={styles.textAlign}>{data.customMessage}</span>}
            <Stepper />
        </MainContentContainer>
    );
};

export default LandingPageBody;
